import { Constants } from '../../dashboard-constants';

export const SURVEY_TABLE_FIELD_TO_SORT_MAP = Object.freeze({
  [Constants.SURVEY_LISTING_TABLE_HEADERS.AVERAGE_CPI]: 'averageCpi',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.COUNTRY_CODE]: 'countryCode',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.CURRENT_IR]: 'currentIR',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.FIELDED]: 'fielded',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.IN_PROGRESS]: 'inProgress',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.LAUNCH_DATE]: 'launchDate',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.LOI]: 'LOI',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.PROJECT_COST]: 'projectCost',
  [Constants.RECONCILIATION.KEY]: 'reconciliation', // Reconciliation key is different from the table header key
  [Constants.SURVEY_LISTING_TABLE_HEADERS.SURVEY_ID]: 'survey',
  [Constants.SURVEY_LISTING_TABLE_HEADERS.SURVEY_TITLE]: 'title',
  scorePercentage: 'score',
});
